import apiClient from './apiClient';

const API_URL = '/tramites/jubilacion';

// Listar / filtrar trámites de Jubilación
export const getTramitesJubilacion = async (idCliente = null, subtipo = null, idEstadoActual = null) => {
    const params = {};
    if (idCliente && idCliente.trim() !== '') params.idCliente = idCliente;
    if (subtipo && subtipo.trim() !== '') params.subtipo = subtipo;
    if (idEstadoActual) params.idEstadoActual = idEstadoActual;

    const response = await apiClient.get(API_URL, { params });
    return response.data;
};

// Detalle de un trámite (incluye empleadores y checklist)
export const getTramiteJubilacionById = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};

// Crear un nuevo trámite de Jubilación
export const crearTramiteJubilacion = async (tramiteData) => {
    try {
        const response = await apiClient.post(API_URL, tramiteData);
        return response.data;
    } catch (error) {
        console.error('Error al crear trámite de Jubilación:', error.response?.data || error.message);
        throw error;
    }
};

// Preview en vivo del checklist de formularios (función pura del backend). Los documentos por
// empleador (PS 2.93 / 2.94 / Recibos) ya no viajan acá: se calculan por empleador (ver
// actualizarDocumentoEmpleador) y se muestran al lado de cada uno, no en el checklist general.
export const getChecklistFormularios = async ({ subtipo, idRegimen, aportesProvinciaNoTransferida, generaSicam }) => {
    const params = { subtipo };
    if (idRegimen) params.idRegimen = idRegimen;
    if (aportesProvinciaNoTransferida) params.aportesProvinciaNoTransferida = true;
    if (generaSicam) params.generaSicam = true;

    const response = await apiClient.get(`${API_URL}/formularios`, { params });
    return response.data;
};

// Editar datos del trámite (no cliente ni subtipo)
export const actualizarTramiteJubilacion = async (id, dto) => {
    const response = await apiClient.put(`${API_URL}/${id}`, dto);
    return response.data;
};

// Actualizar observaciones/comentarios (nota editable con firma)
export const actualizarComentariosJubilacion = async (id, comentarios) => {
    const response = await apiClient.patch(`${API_URL}/${id}/comentarios`, { comentarios });
    return response.data;
};

// Actualizar un ítem del checklist (marcar presentado / adjuntar archivo)
export const actualizarChecklistItem = async (idItem, { presentado, idArchivo }) => {
    const response = await apiClient.patch(`${API_URL}/formularios/${idItem}`, { presentado, idArchivo });
    return response.data;
};

// Actualizar un documento de UN empleador puntual (PS 2.93 / 2.94 / Recibos)
export const actualizarDocumentoEmpleador = async (idEmpleador, idFormulario, { presentado, idArchivo }) => {
    const response = await apiClient.patch(`${API_URL}/empleadores/${idEmpleador}/documentos/${idFormulario}`, { presentado, idArchivo });
    return response.data;
};

const jubilacionService = {
    getTramitesJubilacion,
    getTramiteJubilacionById,
    crearTramiteJubilacion,
    getChecklistFormularios,
    actualizarChecklistItem,
    actualizarDocumentoEmpleador,
    actualizarTramiteJubilacion,
    actualizarComentariosJubilacion,
};

export default jubilacionService;
